export default class FilterViewModel {
    search: string;
    aptitudes: string[];
    isArmada?: boolean;
    isNN?: boolean;
    isIndexed: boolean;
    minIndex: number;
    maxIndex: number;
    schemaId: number;
    isPremium?: boolean;
    boarId:number;
    groupId: number;

    constructor() {
        this.search = "";
        this.aptitudes = [];
        this.isArmada = undefined;
        this.isNN = undefined;
        this.isIndexed = false;
        this.minIndex = 110;
        this.maxIndex = 140;
        this.schemaId = 0;
        this.groupId = 0;
        this.isPremium = undefined;
        this.boarId = 0;

    }

    isEmpty(): boolean {
        return (
            this.search.length == 0
            && this.aptitudes.length == 0
            && (this.isArmada == undefined || this.isArmada == false)
            && (this.isNN == undefined || this.isNN == false)
            && !this.isIndexed
            && this.schemaId == 0
            && (this.isPremium == undefined || this.isPremium == false)
            && this.boarId == 0
            && this.groupId == 0
        );
    }
}
